<div class="wrapper">
  <h1 class="title">Bienvenido</h1>
  <app-image class="image" img="/images/success.png" alt="Login Image">
  </app-image>
  <h2 class="subtitle">Backoffice Calentamiento de Agua</h2>
  <p class="message">Debes ingresar tus credenciales para continuar</p>
  <app-button
    label="Iniciar sesión"
    variant="primary"
    type="button"
    class="button"
    (onClick)="handleClick()"
  ></app-button>
  @if (showModal()) {
    <app-dialog
      title="Atención"
      [showCancel]="true"
      (handleCancel)="closeModal()"
    >
      <div class="modalWrapper">
        <app-image class="image" img="/images/warning.png" alt="Login Image">
        </app-image>
        <p>{{ reason }}</p>
      </div>
    </app-dialog>
  }
</div>
